import * as React from 'react';

export function TimeHalfPastSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}>
      <path d="M11 13.723a1.984 1.984 0 010-3.446V7a1 1 0 012 0v3.277a1.984 1.984 0 010 3.446V16a1 1 0 01-2 0zM12 0a1 1 0 000 2 10 10 0 010 20 1 1 0 000 2 12 12 0 000-24zM1.827 6.784a1 1 0 101 1 1 1 0 00-1-1zM2 12a1 1 0 10-1 1 1 1 0 001-1zm2.221-8.793a1 1 0 101 1 1 1 0 00-1-1zM7.779.841a1 1 0 101 1 1 1 0 00-1-1zM1.827 15.216a1 1 0 101 1 1 1 0 00-1-1zm2.394 3.577a1 1 0 101 1 1 1 0 00-1-1zm3.558 2.366a1 1 0 101 1 1 1 0 00-1-1z" />
    </svg>
  );
}
